export default {
  data() {
    return {
      answersOnboarding: null,
    }
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    isOnboardingComplete() {
      return this.$store.state.onboardingCreateSite.onboarding_complete
    },
  },

  watch: {
    logonToken(payload) {
      if (payload && payload.token && payload.token_payload.wed_id) {
        this.redirectLastStepOnboarding()
      }
    },
  },

  mounted() {
    if (
      this.logonToken &&
      this.logonToken.token &&
      this.logonToken.token_payload.wed_id
    ) {
      this.redirectLastStepOnboarding(this.logonToken)
    }
  },

  methods: {
    verifyStatusOnboarding() {
      const wed_id = this.$store.state.app.logonToken.token_payload.wed_id

      this.answersOnboarding = JSON.parse(
        localStorage.getItem(`onboarding_wed${wed_id}`)
      )
    },

    redirectLastStepOnboarding() {
      this.verifyStatusOnboarding()

      if (
        this.answersOnboarding &&
        this.answersOnboarding.onboarding_complete
      ) {
        this.$router.push({ path: '/onboarding/passo-11' })
      }
    },

    test() {
      return true
    },
  },
}
